(() => {
  'use strict';


  const ROOT_SELECTOR =
    '[data-cce-gifts]';


  /* ==========================================================
     FILTER SYSTEM
     ========================================================== */

  function setupFilters(root) {

    const cards =
      Array.from(
        root.querySelectorAll(
          '[data-cce-product]'
        )
      );


    const categoryButtons =
      Array.from(
        root.querySelectorAll(
          '[data-cce-category]'
        )
      );


    const availabilitySelect =
      root.querySelector(
        '[data-cce-availability]'
      );


    const sortSelect =
      root.querySelector(
        '[data-cce-sort]'
      );


    const clearButton =
      root.querySelector(
        '[data-cce-clear]'
      );


    const emptyReset =
      root.querySelector(
        '[data-cce-empty-reset]'
      );


    const grid =
      root.querySelector(
        '[data-cce-product-grid]'
      );


    const emptyState =
      root.querySelector(
        '[data-cce-empty]'
      );


    const primaryCount =
      root.querySelector(
        '[data-cce-visible-count]'
      );


    const secondaryCount =
      root.querySelector(
        '[data-cce-visible-count-secondary]'
      );


    const currentCategoryLabel =
      root.querySelector(
        '[data-cce-current-category]'
      );


    let activeCategory =
      'all';


    const labels = {

      all:
        'All Gifts',

      'gift-set':
        'Gift Sets',

      candle:
        'Candles',

      diffuser:
        'Diffusers + Warmers',

      oil:
        'Oils',

      japanese:
        'Japanese Care',

      perfume:
        'Perfume',

      accessory:
        'Gift Accessories',

      other:
        'More Gifts'

    };


    /* ========================================================
       SORT
       ======================================================== */

    function sortCards() {

      if (
        !grid ||
        !sortSelect
      ) {
        return;
      }


      const method =
        sortSelect.value;


      const sorted =
        [...cards];


      sorted.sort(
        (a, b) => {

          if (
            method ===
            'price-low'
          ) {

            return (
              Number(a.dataset.price || 0) -
              Number(b.dataset.price || 0)
            );

          }


          if (
            method ===
            'price-high'
          ) {

            return (
              Number(b.dataset.price || 0) -
              Number(a.dataset.price || 0)
            );

          }


          if (
            method ===
            'title-az'
          ) {

            return String(
              a.dataset.title || ''
            ).localeCompare(
              String(
                b.dataset.title || ''
              )
            );

          }


          if (
            method ===
            'title-za'
          ) {

            return String(
              b.dataset.title || ''
            ).localeCompare(
              String(
                a.dataset.title || ''
              )
            );

          }


          if (
            method ===
            'newest'
          ) {

            return (
              Number(
                b.dataset.created || 0
              ) -
              Number(
                a.dataset.created || 0
              )
            );

          }


          return (
            Number(
              a.dataset.originalIndex || 0
            ) -
            Number(
              b.dataset.originalIndex || 0
            )
          );

        }
      );


      sorted.forEach(
        (card) => {

          grid.appendChild(card);

        }
      );

    }


    /* ========================================================
       MATCH
       ======================================================== */

    function matches(card) {

      const category =
        card.dataset.category ||
        'other';


      const available =
        card.dataset.available ===
        'true';


      const availability =
        availabilitySelect
          ?
            availabilitySelect.value
          :
            'all';


      if (
        activeCategory !== 'all' &&
        category !== activeCategory
      ) {
        return false;
      }


      if (
        availability ===
          'available' &&
        !available
      ) {
        return false;
      }


      if (
        availability ===
          'unavailable' &&
        available
      ) {
        return false;
      }


      return true;

    }


    /* ========================================================
       APPLY
       ======================================================== */

    function applyFilters() {

      sortCards();


      let visible =
        0;


      cards.forEach(
        (card) => {

          const show =
            matches(card);


          card.hidden =
            !show;


          if (show) {
            visible += 1;
          }

        }
      );


      if (primaryCount) {

        primaryCount.textContent =
          visible;

      }


      if (secondaryCount) {

        secondaryCount.textContent =
          visible;

      }


      if (currentCategoryLabel) {

        currentCategoryLabel.textContent =
          labels[activeCategory] ||
          'Gifts';

      }


      if (emptyState) {

        emptyState.hidden =
          visible !== 0;

      }


      if (grid) {

        grid.hidden =
          visible === 0;

      }

    }


    /* ========================================================
       CATEGORY
       ======================================================== */

    function setCategory(category) {

      activeCategory =
        category ||
        'all';


      categoryButtons.forEach(
        (button) => {

          const active =
            button.dataset.cceCategory ===
            activeCategory;


          button.classList.toggle(
            'is-active',
            active
          );


          button.setAttribute(
            'aria-pressed',
            active
              ?
                'true'
              :
                'false'
          );

        }
      );


      applyFilters();

    }


    categoryButtons.forEach(
      (button) => {

        button.addEventListener(
          'click',
          () => {

            setCategory(
              button.dataset.cceCategory
            );

          }
        );

      }
    );


    if (availabilitySelect) {

      availabilitySelect.addEventListener(
        'change',
        applyFilters
      );

    }


    if (sortSelect) {

      sortSelect.addEventListener(
        'change',
        applyFilters
      );

    }


    /* ========================================================
       RESET
       ======================================================== */

    function resetFilters() {

      if (availabilitySelect) {

        availabilitySelect.value =
          'all';

      }


      if (sortSelect) {

        sortSelect.value =
          'featured';

      }


      setCategory('all');

    }


    if (clearButton) {

      clearButton.addEventListener(
        'click',
        resetFilters
      );

    }


    if (emptyReset) {

      emptyReset.addEventListener(
        'click',
        resetFilters
      );

    }


    applyFilters();

  }


  /* ==========================================================
     MOBILE FILTER PANEL
     ========================================================== */

  function setupMobilePanel(root) {

    const toggle =
      root.querySelector(
        '[data-cce-filter-toggle]'
      );


    const panel =
      root.querySelector(
        '[data-cce-filter-panel]'
      );


    if (
      !toggle ||
      !panel
    ) {
      return;
    }


    toggle.addEventListener(
      'click',
      () => {

        const open =
          toggle.getAttribute(
            'aria-expanded'
          ) !== 'true';


        toggle.setAttribute(
          'aria-expanded',
          open
            ?
              'true'
            :
              'false'
        );


        panel.classList.toggle(
          'is-open',
          open
        );

      }
    );


    const desktop =
      window.matchMedia(
        '(min-width: 750px)'
      );


    function resetPanel(event) {

      if (!event.matches) {
        return;
      }


      toggle.setAttribute(
        'aria-expanded',
        'false'
      );


      panel.classList.remove(
        'is-open'
      );

    }


    if (desktop.addEventListener) {

      desktop.addEventListener(
        'change',
        resetPanel
      );

    }

  }


  /* ==========================================================
     QUICK ADD
     ========================================================== */

  function setupQuickAdd(root) {

    const buttons =
      Array.from(
        root.querySelectorAll(
          '[data-cce-add]'
        )
      );


    buttons.forEach(
      (button) => {

        button.addEventListener(
          'click',
          async () => {

            const variantId =
              Number(
                button.dataset.variantId
              );


            if (!variantId) {
              return;
            }


            const product =
              button.closest(
                '[data-cce-product]'
              );


            const message =
              product
                ?
                  product.querySelector(
                    '[data-cce-message]'
                  )
                :
                  null;


            const originalHTML =
              button.innerHTML;


            button.disabled =
              true;


            button.textContent =
              'Adding…';


            if (message) {

              message.textContent =
                '';

            }


            try {

              const shopRoot =
                (
                  window.Shopify &&
                  window.Shopify.routes &&
                  window.Shopify.routes.root
                )
                  ?
                    window.Shopify.routes.root
                  :
                    '/';


              const response =
                await fetch(
                  `${shopRoot}cart/add.js`,
                  {
                    method:
                      'POST',

                    headers: {

                      'Content-Type':
                        'application/json',

                      'Accept':
                        'application/json'

                    },

                    body:
                      JSON.stringify(
                        {
                          items: [
                            {
                              id:
                                variantId,

                              quantity:
                                1
                            }
                          ]
                        }
                      )
                  }
                );


              if (!response.ok) {

                throw new Error(
                  'Unable to add product'
                );

              }


              await response.json();


              button.textContent =
                'Added ✓';


              if (message) {

                message.textContent =
                  'Added to cart.';

              }


              document.dispatchEvent(
                new CustomEvent(
                  'cart:refresh'
                )
              );


              document.dispatchEvent(
                new CustomEvent(
                  'cart:updated'
                )
              );


              window.setTimeout(
                () => {

                  button.disabled =
                    false;


                  button.innerHTML =
                    originalHTML;


                  if (message) {

                    message.textContent =
                      '';

                  }

                },
                1700
              );

            } catch (error) {

              button.disabled =
                false;


              button.innerHTML =
                originalHTML;


              if (message) {

                message.textContent =
                  'Please try again.';

              }

            }

          }
        );

      }
    );

  }


  /* ==========================================================
     INITIALISE
     ========================================================== */

  function initialise(root) {

    if (!root) {
      return;
    }


    if (
      root.dataset
        .cceGiftsInitialised ===
      'true'
    ) {
      return;
    }


    root.dataset
      .cceGiftsInitialised =
      'true';


    setupFilters(root);

    setupMobilePanel(root);

    setupQuickAdd(root);

  }


  function initialiseAll(
    scope = document
  ) {

    Array.from(
      scope.querySelectorAll(
        ROOT_SELECTOR
      )
    ).forEach(
      initialise
    );

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      () => {

        initialiseAll(document);

      }
    );

  } else {

    initialiseAll(document);

  }


  document.addEventListener(
    'shopify:section:load',
    (event) => {

      initialiseAll(
        event.target
      );

    }
  );

})();